import MainPage from './MainPage.js'

function App() {
  return (
    <>
      <a className="skip-link" href="#main-content">Skip to content</a>
      <MainPage />
    </>
  );
}

export default App;
